<template>
  <div class="row">
    <div class="col-6 p-0 m-0 d-none d-lg-block" v-if="exibirImagem">
      <b-img-lazy
        v-bind="{
          center: true,
          fluidGrow: true,
          blank: true,
          blankColor: '#bbb',
          class: 'img-fluid painel-imagem-lateral h-100'
        }"
        :src="obterImagemLateral"
        alt="imagem lateral" >
      </b-img-lazy>
    </div>
    <div class="col scrollable-div" v-if="exibirFormulario">
      <div class="modal-wrapper d-flex align-items-center justify-content-center w-100 my-auto mx-auto">
        <div class="modal-content">
          <div class="modal-body">
            <div class="d-flex justify-content-center mb-3">
              <img alt="logo" :src="obterLogo" class="img-fluid painel-logo">
            </div>
            <slot name="cabecalho"></slot>
            <slot name="corpo"></slot>
          </div>
        </div>
      </div>
      <slot name="rodape">
        <div class="text-center painel-rodape">
          <p class="small">Mirt © {{obterAnoAtual}} Todos os direitos reservados</p>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { obterImagem } from '@/util/imagem'
import { iniciarChat } from '@/components/global/SuporteOnline'

export default {
  name: 'PainelAcesso',
  props: {
    exibirImagem: {
      type: Boolean,
      default: true
    },
    exibirFormulario: {
      type: Boolean,
      default: true
    },
    imagem: {
      type: String,
      default: 'imagem-lateral-login.png'
    },
    logo: {
      type: String,
      default: 'logo-mirt-horizontal.svg'
    }
  },
  computed: {
    obterImagemLateral () {
      return obterImagem(this.imagem)
    },
    obterLogo () {
      return obterImagem(this.logo)
    },
    obterAnoAtual () {
      try {
        const ano = new Date().getFullYear()
        return ano
      } catch (e) {
        console.error('Erro ao obter ano:', e)
        return 2024
      }
    }
  },
  data: () => ({
  }),
  methods: {
  },
  async mounted () {
    await iniciarChat(this)
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy () {
    document.body.style.overflow = 'auto'
  }
}

</script>
<style scoped>

@import "./scss/painel-acesso.scss";
</style>
